import React from 'react'
import ConditionalWrapper from '@atoms/ConditionalWrapper/ConditionalWrapper'
import { HotSpotBubbleProps } from './HotSpotBubble.types'
import CustomLink from '@atoms/CustomLink/CustomLink'

const HotSpotBubble = ({
  content,
  headline = '',
  index = 0,
  isActive = false,
  link = '',
  onSelect = () => {},
  xPosition,
  yPosition
}: HotSpotBubbleProps) => {
  if (!xPosition && !yPosition) return <></>

  return (
    <ConditionalWrapper
      condition={link?.length > 0}
      wrapper={(children: any) => (
        <CustomLink inline href={link}>
          {children}
        </CustomLink>
      )}
    >
      <button
        type='button'
        style={{ top: `${yPosition}%`, left: `${xPosition}%` }}
        className={`hotSpotBubble ${isActive ? 'hotSpotBubbleActive' : ''}`}
        onClick={() => onSelect(headline, index, content)}
      >
        <span />
      </button>
    </ConditionalWrapper>
  )
}

export default HotSpotBubble
